import type { Thunk } from 'editor/src/store/hooks';

import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';

import { getLibraryRequest, isImageSaved, isLibraryEnabled } from '../selector';
import { setLibraryRequestAction } from '../slice';

import failUnansweredLibraryRequestOperation from './failUnansweredLibraryRequestOperation';

/** Asks the host to drop an image from the customer's library. The asset and designs using it stay. */
const removeImageFromLibraryOperation =
  (imageId: string): Thunk =>
  (dispatch, getState) => {
    const state = getState();
    if (
      !isLibraryEnabled(state) ||
      !isImageSaved(state, imageId) ||
      getLibraryRequest(state, imageId)?.status === 'pending'
    ) {
      return;
    }

    dispatch(setLibraryRequestAction({ imageId, request: { status: 'pending', saved: false } }));
    sendPostMessage('gallery.removeFromLibrary', { imageId });
    dispatch(failUnansweredLibraryRequestOperation(imageId));
  };

export default removeImageFromLibraryOperation;
